<template>
  <nav class="navigator">
    <ul class="navigator__menu">
      <li
        v-for="(item, i) in navigator[currentLang]"
        :key="i"
      >
        <router-link :to="item.url">
          {{ item.voice }}
        </router-link>
      </li>
    </ul>

    <ul class="navigator__lang">
      <li v-if="currentLang !== 'it'">
        <a @click.prevent="changeLang('it')">
          <img src="/img/app/it-flag.svg" alt="italian flag">
        </a>
      </li>
      <li v-else>
        <a @click.prevent="changeLang('en')">
          <img src="/img/app/en-flag.svg" alt="england flag">
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
import { mapState } from 'vuex';
import navigator from '@/assets/data/navigator.json';

export default {
  name: 'HeaderNavigator',

  data() {
    return {
      navigator,
    };
  },

  computed: {
    ...mapState(['currentLang']),
  },

  methods: {
    changeLang(langTo) {
      const indexEl = this.navigator[this.currentLang].findIndex(el => el.url === this.$route.path);

      this.$store.commit('CHANGE_LANG', langTo);
      if (indexEl < 0) {
        this.$router.push(`/${langTo}`);
      } else {
        this.$router.push(this.navigator[this.currentLang][indexEl].url);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~sass-mq/mq";
@import "../scss/variables";
@import "../scss/functions";

.navigator {
  display: flex;
  align-items: baseline;
  justify-content: flex-end;

  &__menu li {
    display: inline-block;
    margin-left: 40px;

    a {
      display: inline-block;
      position: relative;
      width: 100%;
      box-sizing: content-box;
      opacity: 0.7;
      transition: opacity 0.3s ease-out;
      font-family: 'Apercu';
      color: $color-white;

      &::after {
        content: '';
        position: absolute;
        top: 50%;
        left: -25px;
        width: 14px;
        height: 14px;
        margin-top: -7px;

        background-color: $color-red;
        border-radius: 100%;

        transform: scale(0);
        transition: transform 0.3s ease-out;

        @include mq(ipadP) {
          left: -12px;
          width: 6px;
          height: 6px;
          margin-top: -3px;
        }
      }

      &.router-link-active,
      &:hover {
        opacity: 1;
      }

      &.router-link-active::after {
        transform: scale(1);
      }
    }
  }

  &__lang {
    margin-left: 40px;

    li {
      display: inline-block;

      a {
        font-family: 'Apercu';
        cursor: pointer;
      }

      img {
        position: relative;
        width: 18px;
        height: 18px;
      }
    }
  }

  @include mq($until: ipadP) {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 120px 0 20px;

    background-color: lighten($color-black, 10%);

    font-size: font-size(xml);
    text-transform: capitalize;
    font-weight: normal;

    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-flow: column nowrap;

    opacity: 0;
    pointer-events: none;
    transition: opacity 0.5s ease-in-out;

    .navigator__lang {
      margin-top: 40px;
    }

    .navigator__menu {
      flex: 1 1 auto;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      flex-flow: column nowrap;
    }

    &[data-mobileMenu="visible"] {
      opacity: 1;
      pointer-events: all;
    }
  }
}
</style>
